<div class="progress" [ngClass]="{'progress--hide': percentWidth === 100}">
  <div class="progress__bar" [ngStyle]="{'width': percentWidth + '%'}"></div>
</div>